export default __webpack_public_path__ + "static/media/ATRPortes.82386e46.png";